module.exports = __webpack_public_path__ + "img/Mes_Mulher_630x200.46f68010.jpg";